module.exports = __webpack_public_path__ + "img/not_standard.7b0436cd.png";